import { useContext } from "react";
import { observer } from "mobx-react";
import classNames from "classnames";

import styles from "./styles/PoweredByCS.module.scss";
import ClickableLink from "../utilities/ClickableLink";
import Button from "../utilities/Button";
import { StoreContext } from "../../stores/StoreLoader";
import { LogoutButton } from "../admin/sidebar/items/LogoutButton";
import { isCleversiteApp } from "../../utils/SchoolBlocksUtilities";

const poweredByContainerClassName = classNames({
    [styles.poweredByContainer]: true,
});
const loginButtonClassName = classNames({
    [styles.loginButton]: true,
});

const PoweredBy = observer(props => {
    const {modalStore, userStore, interfaceStore} = useContext(StoreContext);

    function openLogin() {
        modalStore.addModal({
            type: "login",
            size: "lg",
            id: "login-modal",
        });
    }

    let logoutButton;
    if (interfaceStore.isSchoolBlocks) {
        logoutButton = <LogoutButton className={loginButtonClassName}>Logout</LogoutButton>;
    } else {
        logoutButton = <Button className={loginButtonClassName} onClick={userStore.logout}>Logout</Button>
    }

    return (
        <div className={poweredByContainerClassName}>
            <div>
                {userStore.id ? logoutButton
                    : <Button className={loginButtonClassName} onClick={openLogin}>Login</Button>}
            </div>
            <small>This website is powered by <span>
                {(isCleversiteApp())
                    ? <ClickableLink href={"https://www.cleversite.com"}>CleverSite</ClickableLink>
                    : <ClickableLink href={"https://www.schoolblocks.com"}>SchoolBlocks</ClickableLink>
                }
            </span></small>
        </div>
    )
});

export default PoweredBy;
